/**
 * 考试预览
 * @description 考试预览组件
 * @author mll
 * @date 2020-2-14
 */
import React from 'react';
import PropTypes from 'prop-types';
import '@/styles/components/exam/examPreviw/index.less'
import { component_tool } from '../../../tool'
let {
    WizSelect,
    WizTable,
    WizTag,
    WizComponent,
    WizLayout,
    WizRow,
    WizCol,
    WizTypography,
    WizButton,
    WizList,
    WizRadio,
    WizCheckbox,
    WizInput,
    WizDivider
} = component_tool;
const { Header, Content } = WizLayout;
const { Title, Text, Paragraph } = WizTypography
export default class ExamPaperPreview extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.data = props['data']
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps['data']) {
            this.data = nextProps['data']
            return true
        }
        else {
            return false
        }
    }


    /**
     * col各个屏幕大小的适配
     */
    colFree(xs, sm, md, lg, xl, xxl) {
        let size = {
        };
        if (xs) {
            size["xs"] = xs
        }
        if (sm) {
            size["sm"] = sm
        }
        if (md) {
            size["md"] = md
        }
        if (lg) {
            size["lg"] = lg
        }
        if (xl) {
            size["xl"] = xl
        }
        if (xxl) {
            size["xxl"] = xxl
        }
        return size;
    }

    /**
     * 考试标题
     */
    _title = () => {
        let { title,id } = this.data
        if (id) {
        return (
            <WizRow className='exam_title' type={'flex'} justify={'center'} align={'middle'}>
                <Title level={4} ellipsis>{title}</Title>
            </WizRow>
        )
        } else {
            return null
        }
    }

    /**
     * 考试信息
     */
    _info = () => {
        let { totalScore, passScore, limitMinutes, parts, id } = this.data
        let questionSize = 0;
        let partLength = parts ? parts.length : 0
        if (id) {
            if (parts) {
                parts.forEach(p => {
                    if (p['questions'] && p['questions'].length > 0)
                        questionSize += p['questions'].length
                });
            }
            let info = `试卷说明：本试卷共${partLength}大章节，${questionSize}小题，满分${totalScore}分，通过分数${passScore}分，考试时间${limitMinutes}分钟。`
            return (
                <WizRow type={'flex'} justify={'center'} align={'middle'}>
                    <Text ellipsis={true}>{info}</Text>
                </WizRow>
            )
        } else {
            return null
        }

    }

    /**
     * 章节锚点
     */
    _partsAnchor = () => {
        let { parts } = this.data
        if (parts && parts.length > 0) {
            let anchors = []
            parts.forEach(part => {
                anchors.push(
                    <WizCol key={part['id']} className='exam_parts_anchor_col' /*{...this.colFree(8, 7, 5, 5, 4, 3, 3)}*/>
                        <WizButton type="primary" ghost onClick={() => this.scrollToAnchor(part['id'])}>
                            {part['title'] + '( ' + part['questions'].length + '题 )'}
                        </WizButton>
                    </WizCol>
                )
            });
            return (
                <WizRow className='exam_parts_anchor' type={'flex'} align={'middle'}>
                    {anchors}
                </WizRow>
            )
        }
    }

    /**
     * 锚点跳转方法
     */
    scrollToAnchor = (anchorName) => {
        if (anchorName) {
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) { anchorElement.scrollIntoView(); }
        }
    }

    /**
     * 章节迭代
     */
    _parts = () => {
        let _parts = []
        let { parts } = this.data
        if (parts && parts.length > 0) {
            for (let index = 0; index < parts.length; index++) {
                const p = parts[index];
                 _parts.push(this._part(p, index))
            }
        }
        return _parts
    }

    /**
     * 章节
     */
    _part = (part = {}, index) => {
        let title = index + 1 + '. ' + part['title'] + '( 共' + part['size'] + '题，每题' + part['score'] + '分，共' + (part['size'] * part['score']) + '分' + ' )'
        return (
            <div key={part['id']} id={part['id']} type={'flex'}>
                {this.props?.mode !== 1 ? <Paragraph className='exam-preview-parts-title' strong >{title}</Paragraph> : undefined}
                {this._questions(part['questions'])}
            </div>
        )
    }

    /**
     * 问题内容
     */
    _questions = (questions = []) => {
        let r = []
        for (let index = 0; index < questions.length; index++) {
            const question = questions[index];
            r.push(
                <WizList
                    key={'question_' + question['id']}
                    rowKey='id'
                    locale={{ emptyText: ' ' }}
                    header={this._questionTitle(question, index)}
                    footer={this._quetionAnswer(question)}
                    dataSource={question['options'] || []}
                    renderItem={this._renderItem}
                    itemLayout={'vertical'}
                    split={false}
                    size={'small'}
                />
            )
        }

        return r
    }

    _renderItem = (item, index) => {
        let _index = String.fromCharCode(index + 65) + '、'
        let img = item['img'] && item['img'] != '' ? <img src={getOssFilePath(item['img'])} className='question_img' /> : null
        return (
            <div >
                <Paragraph key={'name'}>
                    {_index + item['name'] || ''}
                </Paragraph>
                <div key={'img-div'}>{img}</div>
            </div>
        )
    }


    /**
     * 题干
     */
    _questionTitle = (question, index) => {
        let { title, img, type } = question
        let r = [
            <Paragraph key={'_questionTitle'} strong>
                <Text className='question_title_number'>{index + 1}</Text>
                {title}
            </Paragraph>
        ]
        if (img && img != '') {
            r.push(<img key={'_questionTitleImg'} src={img} className='question_img' />)
        }
        if (type === 3) {
            r.push(
                <WizInput className={'exam-preview-input'} key={'_questionTitleWizInput'} disabled defaultValue='请输入答案' />
            )
        } else if (type === 4) {
            r.push(
                <WizInput.TextArea className={'exam-preview-input'} key={'_questionTitleWizInputTextArea'} disabled defaultValue='请输入答案' />
            )
        }
        return r
    }

    /**
     * 问题答案部分
     */
    _quetionAnswer = (question) => {
        let { correct, analysis, type, options = [] } = question
        let _correct = ''
        if (type === 0) {
            let radio = []
            for (let index = 0; index < options.length; index++) {
                radio.push(
                    <WizRadio key={index} checked={index === correct}> {String.fromCharCode(index + 65)} </WizRadio>
                )
            }
            _correct = radio
        } else if (type === 1) {
            let radio = []
            for (let index = 0; index < options.length; index++) {
                let flag = false;
                correct.forEach(c => {
                    if (c === index) {
                        flag = true
                    }
                });
                radio.push(
                    <WizCheckbox key={index} checked={flag}> {String.fromCharCode(index + 65)} </WizCheckbox>
                )
            }
            _correct = radio
        } else if (type === 2) {
            _correct = [
                <WizRadio key={0} checked={correct === 0}> 正确 </WizRadio>,
                <WizRadio key={1} checked={correct === 1}> 错误 </WizRadio>
            ]
        } else if (type === 3) {
            let _result = []
            for (let index = 0; index < correct.length; index++) {
                const e = correct[index];
                let answer1 = ''
                let answerOther = ''
                for (let i = 0; i < e.length; i++) {
                    const _e = e[i];
                    if (i === 0) {
                        answer1 = _e
                    } else {
                        if (i === e.length - 1) {
                            answerOther += _e
                        } else {
                            answerOther += _e + '，'
                        }
                    }
                }
                let r = [<Paragraph className='exam-preview-answer-4' key={'answer1' + index}><Text>({index + 1})答案：  </Text>{answer1}</Paragraph>]
                if (answerOther !== '') {
                    r.push(<Paragraph key={'answerOther' + index}><Text>备选答案：  </Text>{answerOther}</Paragraph>)
                }
                _result.push(
                    <WizRow key={index}>{r}</WizRow>
                )
            }
            _correct = [<Text key='answer' strong>参考答案：  </Text>, _result];
        } else if(type === 5) {
          const tableView = (type, dataSource = [], scoreRule) => {
            if (!dataSource?.length) {
              return undefined
            }
            const typeEnum = {0: '得分', 1: '失分'}
            const typeStr = typeEnum[type];
            if([undefined, null].indexOf(typeStr) !== -1) {
              return <div/>
            }
            if(!dataSource?.length) {
              return [
                <Text key='answer' strong>{typeStr}规则： </Text>,
                <div style={{margin: '10px 0'}}>暂无{typeStr}规则</div>,
              ]
            }
            return (
              <div>
                <Text key='answer' strong>{typeStr}规则： </Text>
                <WizTable pagination={false} dataSource={dataSource || []}>
                  <WizTable.Column width={60} title={'序号'} dataIndex={'sort'}/>
                  <WizTable.Column
                    title={`${typeStr}关键词`}
                    dataIndex={'list'}
                    render={(list = []) => {
                      return list?.map(item => {
                        const {ruleInfoSort: sort, words} = item;
                        return (
                          <WizTag className='tag-item' key={sort}>
                            {words}
                          </WizTag>
                        )
                      })
                    }}
                  />
                  {
                    scoreRule > 0 ?
                      <WizTable.Column
                        width={180}
                        title={`${typeStr}模式`}
                        dataIndex={'mode'}
                        render={(_, record) => {
                          const {mode, modeValue} = record || {};
                          return <WizInput
                            disabled={true}
                            value={modeValue}
                            addonBefore={
                              <WizSelect disabled={true} value={mode}>
                                <WizSelect.Option value={0}>分数线</WizSelect.Option>
                                <WizSelect.Option value={1}>实际分</WizSelect.Option>
                              </WizSelect>
                            }
                          />
                        }}
                      /> :
                      <WizTable.Column width={170} title={`${typeStr}权重(%)`} dataIndex={'ratio'}/>
                  }
                </WizTable>
                {scoreRule > 0 ? <Text>计算模式：{dataSource.length}选{scoreRule}</Text> : undefined}
              </div>
            )
          }


          _correct = [
            <div>
              <Text key='answer' strong>参考答案： </Text>
              {correct}
            </div>,
            tableView(0, question?.gainList?.filter(item => item?.type === 0), question?.scoreRuleGain),
            tableView(1, question?.lossList?.filter(item => item?.type === 1), 0),
          ];
        } else {
            _correct = [<Text key='answer' strong>参考答案：  </Text>, correct];
        }
        let style = options.length > 0 || type === 1 ? {} : { marginTop: -40, }
        return (
            <div style={style}>
                {[
                    <WizDivider key={question['id'] + 'dashed'} dashed />,
                    <Paragraph key={question['id'] + 'correct'}>{_correct}</Paragraph>,
                    <Paragraph key={question['id'] + 'analysis'}><Text strong>解析：  </Text>{analysis && analysis != '' ? analysis : '暂无解析'}</Paragraph>,
                    <WizDivider key={question['id'] + 'disable'} className='exam-preview-divider' />
                ]}
            </div>
        )
    }

    render() {
        return (
            <WizLayout className="full-layout exam-preview">
                <Header>
                    {this._title()}
                    {this._info()}
                    {!this.props?.hiddenPartsAnchor ? this._partsAnchor() : undefined}
                </Header>
                <Content className='exam-preview-content'>
                    {this._parts()}
                </Content>
            </WizLayout>
        )

    }
}

/**
 * 默认值
 */
ExamPaperPreview.defaultProps = {
}

/**
 * props入参校验
 */
ExamPaperPreview.propTypes = {
}
